/* eslint-disable import/prefer-default-export */
import { createCommand } from 'lexical';

export const INSERT_IMAGE_COMMAND = createCommand('create_image');
